module.exports = __webpack_public_path__ + "static/media/eliteGold.dd830057.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eliteGold.svg
// module id = 6621
// module chunks = 0